import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { MdClose } from 'react-icons/md';

import { PostVideoPlayer } from './post-video-player';

interface VideoPreviewDialogProps {
  src: string | null;
  onClose: () => void;
}

/**
 * Lightbox that plays a picked/attached video with full media controls. Opened
 * from an attachment thumbnail in the composer and the inline edit form so the
 * author can preview a video before (re)posting.
 */
export const VideoPreviewDialog = ({ src, onClose }: VideoPreviewDialogProps) => {
  return (
    <Dialog
      open={!!src}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'visible' } }}
    >
      <Box sx={{ position: 'relative' }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: -40,
            right: 0,
            color: 'white',
            bgcolor: 'rgba(0,0,0,0.4)',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
          }}
        >
          <MdClose />
        </IconButton>
        {src && <PostVideoPlayer src={src} maxHeight={600} />}
      </Box>
    </Dialog>
  );
};
